const ls = {
  get: () => JSON.parse(localStorage.getItem("fluco_cor_recently_viewed")),
  set: val =>
    localStorage.setItem("fluco_cor_recently_viewed", JSON.stringify(val)),
};

export const updateRecentProducts = productHandle => {
  let recentlyViewed = [];
  let productsList = ls.get();

  if (productsList !== null) {
    recentlyViewed = productsList.filter(
      storedHandle => storedHandle !== productHandle
    );

    recentlyViewed.unshift(productHandle);
    ls.set(recentlyViewed.slice(0, 11)); // 1 extra product to account for itself
  } else if (productsList === null) {
    recentlyViewed.push(productHandle);
    ls.set(recentlyViewed);
  }
};

export const getRecentProducts = () => ls.get();
